import React from 'react';
export interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  theme?: 'dark' | 'light';
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  theme = 'dark',
  onClick,
  className = ''
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-300 inline-block text-center font-["Inter"]';
  const variantStyles = {
    primary: 'bg-[#F1B530] text-[#0F0F0F] hover:bg-[#D09F2B] hover:shadow-[0_0_30px_rgba(241,181,48,0.3)] hover:-translate-y-0.5',
    secondary: theme === 'dark' ? 'text-[#A0A0A0] hover:text-[#F5F5F5] underline underline-offset-4 decoration-[#F1B530]/50 hover:decoration-[#F1B530]' : 'text-[#6B6B6B] hover:text-[#1A1A1A] underline underline-offset-4 decoration-[#F1B530]/50 hover:decoration-[#F1B530]'
  };
  const sizeStyles = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-7 py-3.5 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  return <button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-123">
      {children}
    </button>;
}